import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Toolbar } from '@material-ui/core';

const WEToolBarElement = withStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 30px 0 40px',
    width: 'calc(100% - 61px)',
  },
})(Toolbar);

const WETopBar = (props) => {
  return <WEToolBarElement>{props.children}</WEToolBarElement>;
};

export default WETopBar;
